<app-chat-thread
  [title]="'students.messages.title'|translate"
  [subtitle]="studentName"
  [messages]="messages"
  [mySenderType]="senderTypes.Coach"
  [counterpartName]="studentName"
  [placeholder]="'students.messages.placeholder'|translate: {name: studentName}"
  [emptyText]="'students.messages.empty'|translate"
  [loadMoreText]="'students.messages.load_more'|translate"
  [isLoading]="isLoading"
  [isSending]="isSending"
  [hasMore]="hasMore()"
  [errorKey]="errorKey"
  (sent)="send($event)"
  (loadMoreRequested)="loadMore()"></app-chat-thread>
